// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"hourglass"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M19 21H5V19C5 15.134 8.13401 12 12 12C15.866 12 19 15.134 19 19V21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M5 3H19V5C19 8.86599 15.866 12 12 12C8.13401 12 5 8.86599 5 5V3Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 12C15.866 12 19 15.134 19 19V21H5V19C5 15.134 8.13401 12 12 12ZM12 12C8.13401 12 5 8.86599 5 5V3H19V5C19 8.86599 15.866 12 12 12Z","strokeWidth":"props.strokeWidth"}}]}]};

const HourglassIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'hourglass',
    ref,
    icon: element,
  },
));

HourglassIcon.displayName = 'HourglassIcon';

export default HourglassIcon;
